<a *ngIf="( rowData.message_type === 'incoming message' || rowData.message_type === 'interactive-product-incoming' ) && isReply() && rowData.encryption !== 1"
	href="javascript:void(0);" (click)="openReplyPopup()">Reply</a>

<ng-template #replyFormPopup let-c="close" let-d="dismiss">
	<!-- <div class="modal-header"><span align="center"><b>Reply To</b><br />{{ rowData[to] }}</span></div> -->
	<form [formGroup]="replyForm" (ngSubmit)="sendReply()">
		<div class="modal-body">
			<div class="row">
				<div class="col-md-12">
					<app-alert *ngIf="!isAlertClose" (close)="isAlertClose=true" [type]="type" [dismissible]="true"
						[value]="msg"></app-alert>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label for="message">Reply to <span class="number">{{ rowData[to] }}:<span
									class="text-danger">*</span>
							</span>
						</label><br />
						<textarea rows="5" class="form-control" formControlName="message"></textarea>
						<input type="hidden" formControlName="recipient" />
					</div>
					<p class="note">Please note: <span class="note-msg">The recipient will only receive a reply if they respond to your message within 24 hours.</span></p>
				</div>
			</div>
		</div>
		<div class="modal-footer" style="justify-content: center;">
			<button type="button" class="btn btn-secondary btn-lg" style="height: 40px; margin-right: 16px !important;"
				(click)="c('Close click')">Cancel</button>
			<button type="submit" class="btn btn-primary btn-lg nxt-btn-lg" style="height: 40px;margin: 0;"
				[disabled]="!replyForm.valid">Send</button>
		</div>
	</form>
</ng-template>